/**
 * LocaleGuard - Ensures that :locale param is a valid supported locale
 * Prevents conflicts with other dynamic routes like :username
 */

import { languages } from "@stylingcv/utils";
import { Navigate, Outlet, useParams } from "react-router-dom";

export const LocaleGuard = () => {
  const { locale } = useParams<{ locale: string }>();

  // Check if the locale param is a valid supported locale
  const isValidLocale =
    locale && languages.some((lang) => lang.locale.toLowerCase() === locale.toLowerCase());

  if (!isValidLocale) {
    console.log(`[LocaleGuard] Invalid locale "${locale}", redirecting to 404`);
    // If not a valid locale, this might be a username route
    // Let React Router handle it naturally (will fall through to username routes)
    return <Navigate replace to="/404" />;
  }

  console.log(`[LocaleGuard] Valid locale detected: ${locale}`);
  return <Outlet />;
};
